
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-news',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.scss']
})
export class NewsComponent implements OnInit {
  headlines = [
     {
      id: 'PR4',
      title: 'Ascendiun\u00A0CEO Paul Markovich\u00A0Launches National Policy\u00A0Reform Movement to Rebuild American Healthcare System\u00A0That’s\u00A0“Worthy of Us All”',
      date: '2026-03-02',
      summary: 'Ascendiun CEO Paul Markovich launches a national policy reform movement to rebuild the American healthcare system.'
    },
    {
      id: 'PR1',
      title: 'Urgent Need to Fix Americas Healthcare System, Ascendiun CEO Paul Markovich Tells Congress',
      date: '2026-01-22',
      summary: 'Ascendiun CEO Paul Markovich testifies before Congress on the urgent need for healthcare reform. Read more for details.'
    },
    {
      id: 'PR2',
      title: 'Energy and Commerce Committee: Paul Markovich Opening Statement',
      date: '2026-01-22',
      summary: 'Paul Markovich delivers his opening statement to the Energy and Commerce Committee, addressing key healthcare issues.'
    },
    {
      id: 'PR3',
      title: 'Written Testimony of Paul Markovich<br>CEO and President of Ascendiun (parent company of Blue Shield of California)<br>House Committee on Energy & Commerce, Subcommittee on Health<br>Lowering Health Care Costs for All Americans: An Examination of Health Insurance Affordability',
      date: '2026-01-22',
      summary: 'Full written testimony of Paul Markovich on lowering health care costs and improving affordability for all Americans.'
    }
  ]
  expanded: boolean[] = [];
  mail_text = 'mailto:info@ascendiun.com';
  

  ngOnInit(): void {
    this.expanded = this.headlines.map(() => false);
  }

  toggleSummary(index: number): void {
    this.expanded[index] = !this.expanded[index];
  }

  // No parsing required; rich content is rendered directly in the template.

  constructor(private router: Router) {}

  openNewsDetail(pr: string): void {
    this.router.navigate([`/news/${pr.toLowerCase()}`]);
  }
}
